import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { STARFISH_CHILDDEVICE_DETAILS } from './url-constants';

type StarfishChildDeviceDetailsEndpointSpecification = ApiEndpointSpecification;
export const StarfishChildDeviceDetailsEndpointSpecification: StarfishChildDeviceDetailsEndpointSpecification = {
    url: STARFISH_CHILDDEVICE_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'StarfishChildDeviceDetailsRequestParams',
    requestBodySchemaName: 'StarfishChildDeviceDetailsRequestBody',
    okResponseSchemaName: 'StarfishChildDeviceDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:1,
};

export const invokeStarfishChildDeviceDetails = Helpers.makeApiRequestFn<
    Types.StarfishChildDeviceDetailsRequestParams,
    Types.StarfishChildDeviceDetailsRequestBody,
    Types.StarfishChildDeviceDetailsOkResponse
>(StarfishChildDeviceDetailsEndpointSpecification);
